import _defineProperty from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import G6 from '@antv/g6/lib';
import { getShapeName } from '../util/clazz';
import Command from '../plugins/command';
import Toolbar from '../plugins/toolbar';
import AddItemPanel from '../plugins/addItemPanel';
import CanvasPanel from '../plugins/canvasPanel';
import ToolbarPanel from '../components/ToolbarPanel';
import ItemPanel from '../components/ItemPanel';
import DetailPanel from '../components/DetailPanel';
import i18n from '../locales';
import { exportXML, exportImg } from "../util/bpmn";
import registerShape from '../shape';
import registerBehavior from '../behavior';
registerShape(G6);
registerBehavior(G6);
export default {
  name: "wfd-vue",
  components: {
    ToolbarPanel: ToolbarPanel,
    ItemPanel: ItemPanel,
    DetailPanel: DetailPanel
  },
  provide: function provide() {
    return {
      i18n: i18n[this.lang]
    };
  },
  props: {
    isView: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "edit"
    },
    height: {
      type: Number,
      default: 800
    },
    lang: {
      type: String,
      default: "zh"
    },
    data: {
      type: Object,
      default: function _default() {
        return {
          nodes: [],
          edges: []
        };
      }
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    authorities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categorys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    propProcessModel: {
      type: Object,
      default: function _default() {
        return {
          id: '',
          name: '',
          category: '',
          clazz: 'process',
          dataObjs: [],
          signalDefs: [],
          messageDefs: []
        };
      }
    }
  },
  data: function data() {
    return {
      processModel: {},
      resizeFunc: function resizeFunc() {},
      selectedModel: {},
      graph: null,
      cmdPlugin: null
    };
  },
  watch: {
    data: function data(oldData, newData) {
      if (oldData !== newData) {
        if (this.graph) {
          this.graph.changeData(this.initShape(newData));
          this.graph.setMode(this.mode);
          this.graph.emit('canvas:click');
          if (this.cmdPlugin) {
            this.cmdPlugin.initPlugin(this.graph);
          }
          if (this.isView) {
            this.graph.fitView(5);
          }
        }
      }
    }
  },
  methods: {
    initShape: function initShape(data) {
      if (data && data.nodes) {
        return {
          nodes: data.nodes.map(function (node) {
            return _objectSpread({
              shape: getShapeName(node.clazz)
            }, node);
          }),
          edges: data.edges
        };
      }
      return data;
    },
    initEvents: function initEvents() {
      var _this = this;
      this.graph.on('afteritemselected', function (items) {
        if (items && items.length > 0) {
          var item = _this.graph.findById(items[0]);
          if (!item) {
            item = _this.getNodeInSubProcess(items[0]);
          }
          _this.selectedModel = _objectSpread({}, item.getModel());
        } else {
          _this.selectedModel = _this.processModel;
        }
      });
      this.graph.on('aftercommandexecute', function (command) {
        if (command.name !== 'undo' && command.name !== 'redo') return;
        // 更新selectedModel
      });

      var page = this.$refs['canvas'];
      var graph = this.graph;
      var height = this.height - 1;
      this.resizeFunc = function () {
        graph.changeSize(page.offsetWidth, height);
      };
      window.addEventListener("resize", this.resizeFunc);
    },
    onItemCfgChange: function onItemCfgChange(key, value) {
      var items = this.graph.get('selectedItems');
      if (items && items.length > 0) {
        var item = this.graph.findById(items[0]);
        if (!item) {
          item = this.getNodeInSubProcess(items[0]);
        }
        if (this.graph.executeCommand) {
          this.graph.executeCommand('update', {
            itemId: items[0],
            updateModel: _defineProperty({}, key, value)
          });
        } else {
          this.graph.updateItem(item, _defineProperty({}, key, value));
        }
        this.selectedModel = _objectSpread({}, item.getModel());
      } else {
        var canvasModel = _objectSpread(_objectSpread({}, this.processModel), {}, _defineProperty({}, key, value));
        this.selectedModel = canvasModel;
        this.processModel = canvasModel;
      }
    },
    getNodeInSubProcess: function getNodeInSubProcess(itemId) {
      var subProcess = this.graph.find('node', function (node) {
        if (node.get('model')) {
          var clazz = node.get('model').clazz;
          if (clazz === 'subProcess') {
            var containerGroup = node.getContainer();
            var subGroup = containerGroup.subGroup;
            var item = subGroup.findById(itemId);
            return subGroup.contain(item);
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
      if (subProcess) {
        var group = subProcess.getContainer();
        return group.getItem(subProcess, itemId);
      }
      return null;
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.resizeFunc);
    this.graph.getNodes().forEach(function (node) {
      node.getKeyShape().stopAnimate();
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    var plugins = [];
    if (!this.isView) {
      this.cmdPlugin = new Command();
      var toolbar = new Toolbar({
        container: this.$refs['toolbar'].$el
      });
      var addItemPanel = new AddItemPanel({
        container: this.$refs['addItemPanel'].$el
      });
      var canvasPanel = new CanvasPanel({
        container: this.$refs['canvas']
      });
      plugins = [this.cmdPlugin, toolbar, addItemPanel, canvasPanel];
    }
    var width = this.$refs['canvas'].offsetWidth;
    this.graph = new G6.Graph({
      plugins: plugins,
      container: this.$refs['canvas'],
      height: this.height,
      width: width,
      modes: {
        default: ['drag-canvas', 'clickSelected'],
        view: [],
        edit: ['drag-canvas', 'hoverNodeActived', 'hoverAnchorActived', 'dragNode', 'dragEdge', 'dragPanelItemAddNode', 'clickSelected', 'deleteItem', 'itemAlign', 'dragPoint', 'brush-select']
      },
      defaultEdge: {
        shape: 'flow-polyline-round'
      }
    });
    this.graph.saveXML = function () {
      var createFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return exportXML(_this2.graph.save(), _this2.processModel, createFile);
    };
    this.graph.saveImg = function () {
      var createFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return exportImg(_this2.$refs['canvas'], _this2.processModel.name, createFile);
    };
    if (this.isView) this.graph.setMode('view');else this.graph.setMode(this.mode);
    this.graph.data(this.initShape(this.data));
    this.graph.render();
    if (this.isView && this.data && this.data.nodes) {
      this.graph.fitView(5);
    }
    this.initEvents();
  },
  created: function created() {
    this.processModel = this.propProcessModel;
    this.selectedModel = this.processModel;
  }
};